import { appstr } from "./appstr";
import { QAlert } from "../CoreApp/QAlert";
import { Globals } from "../CoreApp/Globals";

export function FinishPubResult() {
  Globals._pubPanel.RemoveWaiting(true);
  var response = Globals._pubPanel["response"];
  if (response != "success") {
    var w = new QAlert();
    w.InitAlert(appstr("Alert"), appstr("copypuberr"), null, Globals._pubPanel.fWSMgr, true);
    Globals._pubPanel.fWSMgr.RenderWS();
  }
}
